import LoyaltyProgram from './LoyaltyProgram.view';

export default LoyaltyProgram;